export default "__VITE_ASSET__cE2TbFuX__"